<script>
import { Event } from '@/plugins/bus';
export default {
    computed: {
        querystring() {
            if (!this.params) {
                return '';
            }
            return (
                '?' +
                Object.keys(this.params)
                    .filter(key => !!this.params[key])
                    .map(key => key + '=' + this.params[key])
                    .join('&')
            );
        }
    },
    methods: {
        async getCampaigns() {
            try {
                this.$wait.start('loading campaigns');
                const response = await this.$api.get(`campaigns`);
                return response.data;
            } catch (err) {
                this.$toast.error('There was an error getting campaigns');
                return null;
            } finally {
                this.$wait.end('loading campaigns');
            }
        },
        async addCampaign(update) {
            try {
                this.$wait.start('add campaign');
                const response = await this.$api.put(`campaigns/${update.id}`, update);
                this.$bus.$emit(Event.CampaignUpdated, { id: update.id });
                this.$toast.success(`Campaign added`);
                return response;
            } catch (err) {
                this.$toast.error(`Could not add Campaign`);
                return null;
            } finally {
                this.$wait.end('add campaign');
            }
        },
        async updateCampaign(update) {
            try {
                this.$wait.start('update campaign');
                const response = await this.$api.post(`campaigns/${update.id}`, update);
                this.$toast.success(`Campaign updated`);
                this.$bus.$emit(Event.CampaignUpdated, { id: update.id });
                return response;
            } catch (err) {
                this.$toast.error(`Could not update Campaign`);
                return null;
            } finally {
                this.$wait.end('update campaign');
            }
        },
        async moveCampaignUnit(campaignUnit, date) {
            try {
                this.$wait.start('moving campaign unit');
                const response = await this.$api.post(`campaigns/units/${campaignUnit.id}`, { date });
                this.$toast.success(`Campaign unit moved`);
                this.$bus.$emit(Event.CampaignUnitMoved, { unit: campaignUnit.id, date });
                return response;
            } catch (err) {
                this.$toast.error(`Could not move campaign unit`);
                return null;
            } finally {
                this.$wait.end('moving campaign unit');
            }
        },
        async completeCampaignUnit(id, command) {
            try {
                this.$wait.start('completing campaign unit');
                const response = await this.$api.post(`campaigns/units/${id}/complete`, command);
                this.$toast.success(`Campaign unit completed`);
                this.$bus.$emit(Event.CampaignCompleted, { unit: id });
                return response;
            } catch (err) {
                this.$toast.error(`Could not complete campaign unit`);
                return null;
            } finally {
                this.$wait.end('completing campaign unit');
            }
        },
        async getCampaignUnits(query) {
            //requires use in conjunction with a mixin that adds params i.e. calendar
            try {
                this.$wait.start('loading campaign units');
                const response = await this.$api.get(`campaigns/units${query || this.querystring}`);
                return response.data;
            } catch (err) {
                if (err.response.status == 404) {
                    return null;
                }
                this.$toast.error('There was an error getting campaign units');
                return null;
            } finally {
                this.$wait.end('loading campaign units');
            }
        }
    }
};
</script>
